import { Sparkle } from "lucide-react";

const ITEMS = [
  "Paris",
  "Nova York",
  "Londres",
  "DHL Express",
  "Western Union",
  "Loja de Roupas",
  "Rio de Janeiro",
  "Miami",
  "Lisboa",
  "Roma",
  "Cidadania Brasileira",
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-serif italic text-3xl sm:text-4xl text-ivory/20 whitespace-nowrap px-6">
          {item}
        </span>
        <Sparkle className="w-4 h-4 text-gold/50 shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative bg-navy-dark border-y border-gold/15 py-8 overflow-hidden"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
